<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="cash-advances-review" color="white"></help-link>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y :disabled="!enableForEditRights&&!enableForApproverRights"> 
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(cashadvances_detail.status)" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(cashadvances_detail.status)}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="showEdit" :key="1" title="Edit Loan Payment Details">
                                <v-list-tile-title small>Edit</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" @click="setForReview" :key="2" title="Set to For Review">
                                <v-list-tile-title small>For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasDeleteRights&&!hasItemsPaid" @click="showDelete" :key="3" title="Delete Cash Advances record">
                                <v-list-tile-title small>Delete</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="4" @click="approve" title="Approve Cash Advances">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&approved_status" :key="5" @click="generateDepositSlip" title="Generate Deposit Slip in PDF">
                                <v-list-tile-title small>Print Deposit Slip</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&approved_status" :key="6" @click="showReleaseFundConfirmation" title="Set status to Fund Released">
                                <v-list-tile-title small>Fund Released</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status)" :key="7" @click="reject" title="Reject Cash Advances">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
            </v-card>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support@sweldonow.ph. Error details: {{errorMessage}}
            </v-alert>

            <!-- details -->
            <v-expansion-panel v-if="!loading" v-model="panel" expand class="mt-5">
                <!-- employee details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text">SUMMARY</span>
                        <v-spacer></v-spacer>
                    </template>
                    <ca-summary :cashadvances_detail="cashadvances_detail" :viewedByOwner="false"></ca-summary>
                </v-expansion-panel-content>

                <!-- payment monthly details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text">PAYMENT SCHEDULE</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-data-table
                        :headers="isMobile ? headers_mobile : headers"
                        :items="cashadvances_schedule"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                        >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <tr>
                                <td>
                                    <span v-if="isMobile">{{ props.item.dueOn | moment('MMM DD') }}</span>
                                    <span v-else>{{ props.item.dueOn | moment('MMM DD, YYYY') }}</span>
                                </td>
                                <td>{{ numFormat.formatNumber(props.item.amountDue) }}</td>
                                <td>
                                    <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                                </td>
                                <td v-if="!isMobile">
                                    <span v-if="props.item.processedOn">
                                        {{ props.item.processedOn | moment('MMM DD, YYYY') }}
                                    </span>
                                </td>
                                <td>
                                    <v-btn icon small v-if="hasEditRights&&commonfn.getStatusDescription(props.item.status)!=='Paid'" @click="editPaymentSchedule(props.item)">
                                        <v-icon small>edit</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table> 
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="selectedCashAdvancesId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <!-- status messaging component -->
        <status-messaging :page_query_id="selectedCashAdvancesId" @refresh="updateHandler"></status-messaging>
    
        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-dialog v-model="dialogOkCancel" persistent width="500">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="fundReleased"></ok-cancel>
        </v-dialog>
        <v-dialog v-model="dialogAddEdit" width="700" persistent>   
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="getCashAdvancesDetail(false)"></add-edit>
        </v-dialog>
        <v-dialog v-model="dialogEditSchedule" width="400" persistent>   
            <edt-schedule ref="editScheduleRef" :dialogEditSchedule.sync="dialogEditSchedule" @send="getCashAdvancesDetail(false)"></edt-schedule>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteCashAdvances"></delete>
        </v-dialog>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'           //for refactor
import cashadvancesApi from '@/api/cashadvances'
import commonData from '@/common/data'              //for refactor
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasEditRights, hasApproverRights, hasDeleteRights } from '@/helpers/access-permissions'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'

export default {     
    name: 'CashAdvances',
    metaInfo: {
        title: 'Cash Advances',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Cash Advances' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit': () => import('@/components/CashAdvances/AddEditCashAdvances'),
        'ca-summary': () => import('@/components/CashAdvances/CashAdvancesSummary'),
        'edt-schedule': () => import('@/components/CashAdvances/EditSchedule'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            x: null, y: null,
            mode: null,
            snackbar: false,
            snackbarText: '',
            error: false,
            errorMessage: '',
            loading: false,
            loading_status: false,
            loading_fundreleased: false,
            loading_delete: false,
            menu_status: false,
            headers: [
                {text: 'Due Date',align: 'left',value: 'dueOn', width: '15%', sortable:true},
                {text: 'Amount Due',align: 'left',value: 'amountDue', width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '15%', sortable:true},
                {text: 'Processed On',align: 'left',value: 'processedOn',  width: '15%', sortable:true},
                {text: 'Edit',align: 'left',value: '',  width: '5%', sortable:false}
            ],
            headers_mobile: [
                {text: 'Due Date',align: 'left',value: 'dueOn', width: '15%', sortable:true},
                {text: 'Amount Due',align: 'left',value: 'amountDue', width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '15%', sortable:true},
                {text: 'Edit',align: 'left',value: '',  width: '5%', sortable:false}
            ],
            dialogAddEdit: false,
            dialogDelete: false,
            dialogEditSchedule: false,
            dialogOkCancelMsg: '',
            dialogOkCancel: false,
            panel: [true, true],
            cashadvances_detail: null,
            cashadvances_schedule: []
        }
    },
    methods: {
        showReleaseFundConfirmation() {
            this.dialogOkCancelMsg = `This action will update the status to <b>Fund Released</b>.<br>Once completed, you will no longer be able to generate the Deposit Slip.`
            this.dialogOkCancel = true
        },
        showDelete() {
            this.$refs.refDeleteComponent.setMessage("Delete this Cash Advances record?")
            this.dialogDelete = true
        },
        editPaymentSchedule(data) {
            this.$refs.editScheduleRef.setData(data)
            this.dialogEditSchedule = true
        },
        async deleteCashAdvances() {
            try {
                this.loading_delete = true
                const data = {
                    cashAdvancesId : this.selectedCashAdvancesId
                }
                const response = await cashadvancesApi.delete(data, pageKeys.cash_advances)
                if (response.status == 200) {
                    this.$router.push('/finance/cashadvances')
                }
                this.loading_delete = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setForReview() {
            try {
                this.loading_status = true
                const data = {
                    cashAdvancesId : this.selectedCashAdvancesId
                }
                const response = await cashadvancesApi.setForReview(data, pageKeys.cash_advances)
                if (response.status == 200) {
                    await this.getCashAdvancesDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.addEditRef.setUpdate(this.cashadvances_detail, pageKeys.cash_advances)
            this.dialogAddEdit = true
        },
        async generateDepositSlip() {
            try {
                this.loading_status = true
                
                const response = await cashadvancesApi.getDepositSlip(this.selectedCashAdvancesId)
                if (response.status == 200) {
                    var blob = new Blob([response.data], { type: 'application/pdf' })
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = `CashAdvances-Deposit-Slip-${this.cashadvances_detail.name}.pdf`
                    link.click()
                }

               this.loading_status = false
            }catch(error){
                this.error = true
                this.loading_status = false
                if (error.toString().includes("400")) {
                    this.errorMessage = `${this.cashadvances_detail.name} has no bank details. Please update bank details in Company > Employees > User Profile page.`
                }
                else {
                    this.error = error
                }
            }
        },    
        async fundReleased() {
            //update status to Fund Released
            try {
                this.dialogOkCancel = false
                this.loading_fundreleased = true
                var data = {
                    cashAdvancesId : this.selectedCashAdvancesId
                }
                const response = await cashadvancesApi.fundReleased(data)
                if (response.status == 200) {
                    await this.getCashAdvancesDetail(false)
                }
                this.loading_fundreleased = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    cashAdvancesId : this.selectedCashAdvancesId
                }
                const response = await cashadvancesApi.approve(data)
                if (response.status == 200) {
                    await this.getCashAdvancesDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    cashAdvancesId : this.selectedCashAdvancesId
                }
                const response = await cashadvancesApi.reject(data)
                if (response.status == 200) {
                    await this.getCashAdvancesDetail(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getCashAdvancesDetail(show_loading) {
            try {
                this.loading = show_loading
                const response = await cashadvancesApi.getDetail(this.selectedCashAdvancesId)
                if (response.status == 200) {
                    this.cashadvances_detail = response.data
                    this.cashadvances_schedule = response.data.paymentSchedule
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getCashAdvancesDetail(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
        getDeductionModeDesc(deductionMode){
            return commonData.deduction_modes.filter(x => {
                return x.deductionMode == deductionMode
            })[0].description
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Cash Advances Details'
        })

        this.getCashAdvancesDetail(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        selectedCashAdvancesId() {
            return this.$route.params.cashAdvancesId
        },
        commentsData() {
            if (this.cashadvances_detail) {
                return {
                    pageQueryId: this.selectedCashAdvancesId,
                    pageItemCreatedBy: this.cashadvances_detail.userId,
                    pageLink: this.$router.currentRoute.path.replace('/cashadvances/','/mycashadvances/'), //should send to owner link
                    pageKey: pageKeys.cash_advances,
                    notificationTypeId: notificationTypes.cash_advances
                }
            }
        },
        created_status() {
            if (this.cashadvances_detail) return this.cashadvances_detail.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.cashadvances_detail) return this.cashadvances_detail.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.cashadvances_detail) return this.cashadvances_detail.status==commonfn.getStatusCode('Approved')
        },
        fundReleased_status() {
            if (this.cashadvances_detail) return this.cashadvances_detail.status==commonfn.getStatusCode('Fund Released')
        },
        rejected_status() {
            if (this.cashadvances_detail) return this.cashadvances_detail.status==commonfn.getStatusCode('Rejected')
        },
        enableForApproverRights() {
            return this.hasApproverRights&&(this.forReview_status||this.rejected_status||this.approved_status)
        },
        enableForEditRights() {
            return this.hasEditRights&&(this.created_status||this.rejected_status)
        },
        hasItemsPaid() {
            return this.cashadvances_schedule.filter(x => {
                return x.status == commonfn.getStatusCode('Paid')
            }).length
        }
    }
}
</script>